import React from "react";
import { connect } from "react-redux";
import Moment from "moment";

const QuestionStatistics: React.FC<any> = (props: any) => {
  return (
    <>
      <div>
        <div>
          <div className="flex gap-4">
            <div className="w-72">
              <h3 className="text-lg dark:text-gray-500 pt-4 pl-6">Info</h3>
              <dl className="rounded-lg bg-white shadow-lg mb-0">
                <div className="flex flex-col px-6 gap-2  border-b border-gray-100 text-left py-6 sm:border-0 sm:border-r">
                  <div>
                    <dt className=" text-lg font-medium text-gray-500 bg-gray-100 px-2 mb-2">
                      Author{" "}
                    </dt>
                    <dd className=" text-lg font-bold text-primary-color dark:text-gray-500 ">
                      {props.question?.createdBy}
                    </dd>
                  </div>
                  <div>
                    <dt className=" text-lg font-medium text-gray-500 bg-gray-100 px-2 mb-2 mt-2">
                      Edited{" "}
                    </dt>
                    <dd className=" w-full text-lg font-bold text-primary-color dark:text-gray-500">
                      {props.question.updatedDate
                        ? Moment(props.question.updatedDate).format(
                            "MM-DD-yyyy"
                          )
                        : ""}
                    </dd>
                  </div>
                </div>
              </dl>
            </div>
            <div className="rounded-lg w-full bg-white shadow-lg ">
              <div className="flex flex-col h-full">
                <h3 className="text-lg pl-6 pt-4 dark:text-gray-500">Stats</h3>
                <dl className=" sm:grid sm:grid-cols-12 h-full">
                  <div className="flex flex-col col-span-3 items-left justify-center border-b border-gray-100 py-6 px-3 text-center sm:border-0 sm:border-r">
                    <dt className="order-2 text-base font-medium text-gray-500">
                      Added to an Assessment
                    </dt>
                    <dd className="order-1 text-2xl font-bold text-primary-color dark:text-gray-500 sm:text-3xl">
                      {props.question?.statistics
                        ? props.question.statistics?.assessmentCount
                        : 0}
                    </dd>
                  </div>
                  <div className="flex flex-col col-span-2 items-center justify-center border-t border-gray-100 py-6 px-3 text-center sm:border-0 sm:border-l">
                    <dt className="order-2 text-base font-medium text-gray-500">
                      Answered
                    </dt>
                    <dd className="order-1 text-2xl font-bold text-primary-color dark:text-gray-500 sm:text-3xl">
                      {props.question?.statistics
                        ? props.question.statistics?.answered
                        : 0}
                    </dd>
                  </div>
                  <div className="flex flex-col col-span-3 items-center justify-center border-t border-gray-100 py-6 px-3 text-center sm:border-0 sm:border-l">
                    <dt className="order-2 text-base font-medium text-gray-500">
                      Answered Correctly
                    </dt>
                    <dd className="order-1 text-2xl font-bold text-primary-color dark:text-gray-500 sm:text-3xl">
                      {props.question?.statistics
                        ? props.question.statistics?.answeredCorrectly
                        : 0}
                    </dd>
                  </div>
                  <div className="flex flex-col col-span-2 items-center justify-center border-t border-gray-100 py-6 px-3 text-center sm:border-0 sm:border-l">
                    <dt className="order-2 text-base font-medium text-gray-500">
                      Percent Correct
                    </dt>
                    <dd className="order-1 text-2xl font-bold text-primary-color dark:text-gray-500 sm:text-3xl">
                      {props.question?.statistics
                        ? props.question.statistics?.percentCorrect
                        : 0}
                      %
                    </dd>
                  </div>
                  <div className="flex flex-col col-span-2 items-center justify-center  border-t border-gray-100 py-6 px-3 text-center sm:border-0 sm:border-l">
                    <dt className="order-2 text-base font-medium text-gray-500">
                      Tickets Submitted
                    </dt>
                    <dd className="order-1 text-2xl font-bold text-primary-color dark:text-gray-500 sm:text-3xl">
                      {props.question?.statistics
                        ? props.question.statistics?.feedbackCount
                        : 0}
                    </dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(QuestionStatistics);
